import { useState } from "react";
import { nextApiFetch } from "cy-util";
import { FetchStatus } from "cy-models";

export type HttpMethod = "PUT" | "DELETE" | "GET" | "POST" | "PATCH";

export interface State<TResponse = any> {
  status: FetchStatus;
  response?: TResponse;
  error?: any;
  fetching: boolean;
  fetched: boolean;
}

export function useFetch<TResponse>() {
  const [status, setStatus] = useState<FetchStatus>("idle");
  const [response, setResponse] = useState<any>();
  const [error, setError] = useState<any>();

  async function _fetch(
    method: HttpMethod,
    url: string,
    body?: any
  ): Promise<State<TResponse>> {
    setStatus("fetching");
    setResponse(undefined);
    setError(undefined);
    try {
      const response = await nextApiFetch<TResponse>(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: body ? JSON.stringify(body) : undefined,
      });

      const status: FetchStatus = "fetched";
      setResponse(response);
      setStatus(status);
      return {
        response,
        status,
        fetching: false,
        fetched: true,
      };
    } catch (error) {
      setStatus("error");
      setError(error);
      return { error, status: "error" } as State<TResponse>;
    }
  }

  const state: State<TResponse> = {
    status,
    error,
    response,
    fetching: status === "fetching",
    fetched: status === "fetched",
  };
  return { fetch: _fetch, state };
}
